import { useProductHead } from '~/scopes/product-core/components/ProductDetailPageBase/composables/useSeo/composables/useProductHead/useProductHead'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useFetchProductPrice } from '~/scopes/product-core/composables/useFetch/useFetchProductPrice/useFetchProductPrice'
import { useFetchReviews } from '~/scopes/product-core/composables/useFetch/useFetchReviews/useFetchReviews'
import { useFetchReviewsSummary } from '~/scopes/product-core/composables/useFetch/useFetchReviewsSummary/useFetchReviewsSummary'
import { useFetchShipping } from '~/scopes/product-core/composables/useFetch/useFetchShipping/useFetchShipping'
import { useFetchTechnicalSpecifications } from '~/scopes/product-core/composables/useFetch/useFetchTechnicalSpecifications/useFetchTechnicalSpecifications'

export function useSeo() {
  const { data: productResponse } = useFetchProduct()
  const { selectedOffer, isOutOfStock } = useFetchPickers()
  const { data: reviewSummaryResponse } = useFetchReviewsSummary()
  const { data: technicalSpecificationsResponse } =
    useFetchTechnicalSpecifications()
  const { data: reviewsResponse } = useFetchReviews()
  // Triggers the server-side service pickers fetch (gated) and exposes the subsidised price
  // for the JSON-LD (PPI-7740).
  const { seoPrice } = useFetchProductPrice()
  const { data: shippingResponse } = useFetchShipping()

  useProductHead(
    productResponse,
    selectedOffer,
    reviewSummaryResponse,
    reviewsResponse,
    technicalSpecificationsResponse,
    isOutOfStock,
    shippingResponse,
    seoPrice,
  )
}
